/* Wishifyy - homepage reviews: continuous, never-stopping marquee.
   Replaces the step/swipe testimonials carousel with a smooth infinite rotate.
   Uses a "recycle ticker": the leftmost card is moved to the end once it scrolls
   out of view, so it loops forever with no jump and stays correct even when the
   section swaps its review cards in. Additive + defensive. Applies to every
   `.mhv2__test-track` (desktop main-home-v2 + mobile wmc-mobile-home). */
(function () {
  var SPEED_DESKTOP = 1.4; // px/frame - a bit faster on desktop
  var SPEED_MOBILE = 0.9;  // gentler on phones (also drives the partners marquee px/sec)

  function gapOf(t) { var g = getComputedStyle(t); return parseFloat(g.gap || g.columnGap || 24) || 24; }
  function slice(n) { return Array.prototype.slice.call(n); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  // ── Card redesign: photo fills the card; review text/stars/name/date sit in a
  //    white bubble overlaid on the photo; no avatar circle. Idempotent. ───────
  var CARD_CSS_DONE = false;
  function injectCardCss() {
    if (CARD_CSS_DONE) return; CARD_CSS_DONE = true;
    var css =
      // Hide the testimonials prev/next on EVERY viewport (continuous rotate, no
      // stepping). Scoped to .mhv2__test-wrap so product carousels (.mhv2__grid-wrap)
      // keep theirs. CSS - not JS - so it covers the mobile section even though
      // setup() only runs on the visible desktop track.
      '.mhv2__test-wrap .mhv2__carousel-btn{display:none!important}' +
      '.mhv2__test[data-wf-card]{position:relative;overflow:hidden;border-radius:18px;padding:0!important;background:#e9e2da;box-shadow:0 12px 32px -14px rgba(0,0,0,.4)}' +
      '.mhv2__test[data-wf-card] .mhv2__test-media{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;margin:0!important}' +
      '.mhv2__test[data-wf-card] .mhv2__test-media img,.mhv2__test[data-wf-card]>img{width:100%!important;height:100%!important;object-fit:cover!important;display:block}' +
      '.mhv2__test[data-wf-card] .mhv2__test-stars{border:none!important;box-shadow:none!important;margin:0 0 6px!important}' +
      '.mhv2__test[data-wf-card] .mhv2__test-stars::after,.mhv2__test[data-wf-card] .mhv2__test-stars::before{display:none!important}' +
      '.mhv2__test[data-wf-card] blockquote{border:none!important;padding:0!important;quotes:none!important;margin:0 0 8px!important;font-size:13px;line-height:1.5;color:#241611;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}' +
      '.mhv2__test[data-wf-card] blockquote::before,.mhv2__test[data-wf-card] blockquote::after{display:none!important}' +
      // Uniform bubble: fixed height so EVERY card's bubble is the same size,
      // regardless of review length / product tag / verified state. Short text
      // still gets the full-size bubble; the footer is pinned to the bottom.
      '.wf-rev-bubble{position:absolute;left:12px;right:12px;bottom:12px;z-index:2;background:#fff;border-radius:16px;padding:12px 14px;box-shadow:0 8px 24px -8px rgba(0,0,0,.35);height:140px;box-sizing:border-box;display:flex;flex-direction:column}' +
      '.wf-rev-foot{display:flex;justify-content:flex-end;gap:6px;align-items:baseline;font-size:12px;flex-wrap:wrap;margin-top:auto}' +
      // Bulletproof the marquee cards against two mobile-only shrink causes: (1) the
      // section's "inactive card" rule (opacity:.55/scale(.94), restored only by
      // .is-active which main-home-v2.js adds ONLY on desktop) and (2) flex-basis:%
      // resolving unstably inside the width:max-content track - both randomly shrank
      // cards at the recycle wrap. A definite vw basis + a transform/opacity pin (higher
      // specificity than the section rules) makes every recycled card stay full-size.
      '.mhv2__test-track>.mhv2__test[data-wf-card]{transform:none!important;opacity:1!important;flex:0 0 84vw!important}' +
      '@media(min-width:990px){.mhv2__test-track>.mhv2__test[data-wf-card]{flex:0 0 360px!important}}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  }
  // Request a sharper image - the source loads a tiny ~160px thumbnail that gets
  // upscaled to ~360px (pixelated). The `width` query param isn't signed, so we
  // can ask the resizer for a bigger one. 480px is the sweet spot: still crisp at
  // our ~346px mobile card (verified - no visible loss vs 600) while ~31% lighter,
  // and since these images are now deferred (armTrack) it's pure data savings.
  function upgradeImg(img) {
    if (!img || img.getAttribute('data-wf-hq')) return;
    img.setAttribute('data-wf-hq', '1');
    try {
      var u = new URL(img.src, location.href);
      if (u.searchParams.has('width') && (parseInt(u.searchParams.get('width'), 10) || 0) < 480) {
        u.searchParams.set('width', '480');
        if (u.searchParams.has('quality')) u.searchParams.set('quality', '82');
        img.removeAttribute('loading'); // it's about to be visible in the marquee
        img.src = u.toString();
      }
    } catch (e) {}
  }
  // Responsive card size via INLINE !important (beats the section's specific mobile
  // width rule). Mobile uses a DEFINITE 84vw - NOT 84%, which resolves unstably in
  // the width:max-content track and randomly halved cards at the recycle wrap.
  function sizeCard(card) {
    var mobile = window.innerWidth < 990;
    card.style.setProperty('flex', mobile ? '0 0 84vw' : '0 0 360px', 'important');
    card.style.setProperty('aspect-ratio', mobile ? '3 / 3.7' : '3 / 4', 'important');
  }

  function styleCard(card) {
    if (!card || card.getAttribute('data-wf-card')) return;
    var media = card.querySelector('.mhv2__test-media') || (card.querySelector('img') && card.querySelector('img').parentElement);
    var stars = card.querySelector('.mhv2__test-stars');
    var text = card.querySelector('.mhv2__test-text');
    if (!media || !text) return; // only restyle photo review cards
    card.setAttribute('data-wf-card', '1');
    sizeCard(card);
    slice(card.querySelectorAll('img')).forEach(upgradeImg);
    var author = card.querySelector('.mhv2__test-author');
    var name = card.querySelector('.mhv2__test-name');
    var meta = card.querySelector('.mhv2__test-meta');
    var bubble = document.createElement('div'); bubble.className = 'wf-rev-bubble';
    if (stars) bubble.appendChild(stars);
    bubble.appendChild(text);
    var f = document.createElement('div'); f.className = 'wf-rev-foot';
    f.innerHTML = '<span style="font-weight:700;color:#6B1E32">• ' + (name ? esc(name.textContent.trim()) : '') + '</span>' +
      (meta ? '<span style="color:#9a8f88">' + esc(meta.textContent.trim()) + '</span>' : '');
    bubble.appendChild(f);
    if (author) author.style.display = 'none';
    card.appendChild(bubble);
  }
  function styleCards(track) { injectCardCss(); slice(track.children).forEach(styleCard); }

  var RESIZE_BOUND = false;
  function bindResize() {
    if (RESIZE_BOUND) return; RESIZE_BOUND = true;
    var tmr;
    window.addEventListener('resize', function () {
      clearTimeout(tmr);
      tmr = setTimeout(function () { slice(document.querySelectorAll('.mhv2__test[data-wf-card]')).forEach(sizeCard); }, 200);
    });
  }

  function setup(track) {
    if (!track || track.getAttribute('data-wf-marquee')) return;
    var kids = slice(track.children);
    if (kids.length < 2) return;
    track.setAttribute('data-wf-marquee', '1');

    // Neutralize the section's own scrollLeft drift (its setInterval keeps writing
    // scrollLeft - make it a harmless no-op so it can't fight the marquee).
    try { Object.defineProperty(track, 'scrollLeft', { configurable: true, get: function () { return 0; }, set: function () {} }); } catch (e) {}

    // Marquee layout: a nowrap row that overflows a clipped wrapper, moved via transform.
    track.style.overflow = 'visible';
    track.style.scrollSnapType = 'none';
    track.style.display = 'flex';
    track.style.flexWrap = 'nowrap';
    track.style.width = 'max-content';
    track.style.paddingLeft = '0';
    track.style.paddingRight = '0';
    track.style.willChange = 'transform';
    var wrap = track.parentElement;
    if (wrap) wrap.style.overflow = 'hidden';

    // Hide the prev/next controls - continuous rotate, no manual stepping.
    var scope = track.closest('[data-carousel]') || wrap || track.parentElement;
    if (scope) slice(scope.querySelectorAll('[data-carousel-prev],[data-carousel-next],.mhv2__carousel-btn'))
      .forEach(function (b) { b.style.setProperty('display', 'none', 'important'); }); // !important: beats the mobile section's own !important show rule

    // Edge-to-edge (full-bleed out of the padded container) + a symmetric fog on
    // BOTH edges. The fog goes on the FIXED wrapper, never the track (which we
    // transform - a mask there would ride along with the cards and vanish).
    var FOG = 'linear-gradient(90deg, transparent 0, #000 7%, #000 93%, transparent 100%)';
    if (scope) {
      scope.style.width = '100vw';
      scope.style.maxWidth = '100vw';
      scope.style.marginLeft = 'calc(50% - 50vw)';
      scope.style.marginRight = 'calc(50% - 50vw)';
      scope.style.paddingLeft = '0';
      scope.style.paddingRight = '0';
      scope.style.overflow = 'hidden';
      scope.style.webkitMaskImage = FOG;
      scope.style.maskImage = FOG;
    }
    // Clear any mask the section put on the track itself.
    track.style.webkitMaskImage = 'none';
    track.style.maskImage = 'none';

    // Redesign the cards (photo-fill + overlaid text bubble) BEFORE cloning, so
    // clones inherit the new look; re-run when the section swaps in real reviews.
    styleCards(track);
    bindResize();
    try { new MutationObserver(function () { styleCards(track); }).observe(track, { childList: true }); } catch (e) {}

    // Make sure there are enough cards to overflow the viewport (so it never runs dry).
    function totalW() { var w = 0; slice(track.children).forEach(function (c) { w += c.offsetWidth + gapOf(track); }); return w; }
    var vw = (wrap && wrap.offsetWidth) || window.innerWidth || 1280;
    var guard = 0;
    while (totalW() < vw * 2 && guard < 4) { kids.forEach(function (n) { track.appendChild(n.cloneNode(true)); }); guard++; }

    // Pause the rotation while the mouse is over the carousel (desktop) or while a
    // finger is dragging (mobile swipe-to-browse, below).
    var paused = false, x = 0, drag = false;
    if (scope) {
      scope.addEventListener('mouseenter', function () { paused = true; });
      scope.addEventListener('mouseleave', function () { if (!drag) paused = false; });
    }

    // Recycle cards at BOTH ends so browsing works either way: the auto-rotate
    // drifts left (recycle leftmost → end); a right-swipe pulls earlier cards back
    // in from the left (recycle last → front). Keeps translateX in a tight range.
    function normalize() {
      var g = 0, first, last, fw, lw;
      while (g++ < 60 && (first = track.children[0])) {
        fw = first.offsetWidth + gapOf(track);
        if (fw > 0 && -x >= fw) { x += fw; track.appendChild(first); } else break;
      }
      g = 0;
      while (g++ < 60 && x > 0 && (last = track.children[track.children.length - 1])) {
        lw = last.offsetWidth + gapOf(track);
        if (lw <= 0) break; // guard: a 0-width card would spin this loop forever
        track.insertBefore(last, track.firstChild); x -= lw;
      }
    }
    function render() { normalize(); track.style.transform = 'translateX(' + x + 'px)'; }

    function tick() {
      if (!paused) { x -= (window.innerWidth < 990 ? SPEED_MOBILE : SPEED_DESKTOP); render(); }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    // ── Swipe-to-browse (mobile): drag left/right with a finger to scrub through
    //    the reviews; the auto-rotate pauses while a finger is down and resumes on
    //    release. Only a clearly-horizontal gesture is captured (touch-action:pan-y
    //    + axis lock), so a vertical swipe still scrolls the page past the section.
    var sX = 0, sY = 0, lastX = 0, ax = 0; // ax: 0 undecided | 1 horizontal | -1 vertical
    function dStart(px, py) { drag = false; ax = 0; sX = px; sY = py; lastX = px; }
    function dMove(px, py, e) {
      var dx = px - sX, dy = py - sY;
      if (ax === 0) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        ax = Math.abs(dx) > Math.abs(dy) ? 1 : -1;
        if (ax === 1) { drag = true; paused = true; lastX = px; } // reset baseline so the 6px threshold move isn't double-counted
      }
      // INCREMENTAL: add only the delta since the last move. Absolute (sTx+dx)
      // breaks because normalize() reorders cards mid-drag, so a fixed base goes
      // stale and every move re-triggers a full-card recycle (cards raced by ~24×).
      if (ax === 1) { if (e.cancelable) e.preventDefault(); x += (px - lastX); lastX = px; render(); }
    }
    function dEnd() { if (drag) { drag = false; paused = false; } ax = 0; }
    var dEl = scope || wrap || track;
    try { dEl.style.touchAction = 'pan-y'; track.style.touchAction = 'pan-y'; } catch (e) {}
    dEl.addEventListener('touchstart', function (e) { if (e.touches[0]) dStart(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    dEl.addEventListener('touchmove', function (e) { if (e.touches[0]) dMove(e.touches[0].clientX, e.touches[0].clientY, e); }, { passive: false });
    dEl.addEventListener('touchend', dEnd, { passive: true });
    dEl.addEventListener('touchcancel', dEnd, { passive: true });
  }

  // ── Partners / "Партньорства и участия" marquee: match the reviews' linear
  //    speed. The block scrolls via a CSS keyframe (translateX -N%) over a fixed
  //    duration on a `width:max-content` track. We recompute the DURATION from the
  //    track's real width × that percent so its px/s equals the reviews' speed
  //    (42px/s desktop, 27px/s mobile). Re-run after the logos load + on resize,
  //    since max-content width depends on the loaded images. Defensive + additive.
  function kfPercent(name) {
    if (!name || name === 'none') return 0;
    for (var i = 0; i < document.styleSheets.length; i++) {
      var rules; try { rules = document.styleSheets[i].cssRules; } catch (e) { continue; }
      if (!rules) continue;
      for (var j = 0; j < rules.length; j++) {
        var r = rules[j];
        if (r.type === CSSRule.KEYFRAMES_RULE && r.name === name) {
          // Read each step's transform value only - NOT the rule text, whose
          // keyframe selectors ("0%","100%") would otherwise be mistaken for the
          // translate distance.
          var max = 0;
          for (var k = 0; k < r.cssRules.length; k++) {
            var tr = (r.cssRules[k].style && r.cssRules[k].style.transform) || '';
            var m = tr.match(/-?[\d.]+%/g);
            if (m) m.forEach(function (s) { var v = Math.abs(parseFloat(s)); if (v > max) max = v; });
          }
          return max;
        }
      }
    }
    return 0;
  }
  function matchPartnerSpeed() {
    var target = (window.innerWidth < 990 ? SPEED_MOBILE : SPEED_DESKTOP) * 60; // px/sec - same as the reviews
    slice(document.querySelectorAll('.mhv2__marquee-track, .partners__track')).forEach(function (t) {
      var pct = kfPercent(getComputedStyle(t).animationName);
      if (!pct) return;
      var dist = t.offsetWidth * (pct / 100); // distance one loop travels
      if (dist <= 0) return;
      t.style.setProperty('animation-duration', (dist / target).toFixed(2) + 's', 'important');
    });
  }
  var PARTNERS_BOUND = false;
  function initPartners() {
    matchPartnerSpeed();
    if (PARTNERS_BOUND) return; PARTNERS_BOUND = true;
    window.addEventListener('load', matchPartnerSpeed);
    var tmr; window.addEventListener('resize', function () { clearTimeout(tmr); tmr = setTimeout(matchPartnerSpeed, 200); });
    [600, 1500, 3000].forEach(function (d) { setTimeout(matchPartnerSpeed, d); }); // re-settle as logos load
  }

  // A testimonials track is only "ready" once the real-reviews fetch (in
  // main-home-v2.liquid) has injected its photo cards - until then it holds just
  // the single `data-rev-fallback` figure. setup() bails on <2 kids and never
  // retries, so running it early PERMANENTLY skips that track (the mobile carousel
  // then keeps its old stepping look). Fix the load-order RACE: mount the moment
  // ≥2 real cards exist, and WATCH (MutationObserver + timed retries) any track
  // that isn't ready yet, mounting it as soon as the fetch lands.
  // ── Skeleton loading: while the real-reviews fetch is still pending, show shimmer
  //    placeholder cards instead of the text-only manual fallback (which read like
  //    fake reviews). Removed the instant the real photo cards mount.
  var SKEL_CSS_DONE = false;
  function injectSkelCss() {
    if (SKEL_CSS_DONE) return; SKEL_CSS_DONE = true;
    var css =
      '.wf-skel{flex:0 0 84vw;aspect-ratio:3/3.7;border-radius:18px;background:#e9e2da;position:relative;overflow:hidden;margin:0;list-style:none}' +
      '@media(min-width:990px){.wf-skel{flex:0 0 360px;aspect-ratio:3/4}}' +
      '.wf-skel::after{content:"";position:absolute;inset:0;background:linear-gradient(90deg,rgba(255,255,255,0) 20%,rgba(255,255,255,.55) 50%,rgba(255,255,255,0) 80%);background-size:220% 100%;animation:wfSkelShim 1.25s ease-in-out infinite}' +
      '@keyframes wfSkelShim{0%{background-position:120% 0}100%{background-position:-120% 0}}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  }
  function showSkeleton(track) {
    if (track.getAttribute('data-wf-skel')) return; track.setAttribute('data-wf-skel', '1');
    injectSkelCss();
    slice(track.querySelectorAll('[data-rev-fallback]')).forEach(function (f) { f.style.display = 'none'; }); // hide text fallback - skeleton stands in
    for (var i = 0; i < 4; i++) { var s = document.createElement('div'); s.className = 'wf-skel'; s.setAttribute('data-wf-skel-card', '1'); track.appendChild(s); }
  }
  function clearSkeleton(track) {
    slice(track.querySelectorAll('[data-wf-skel-card]')).forEach(function (s) { if (s.parentNode) s.parentNode.removeChild(s); });
    track.removeAttribute('data-wf-skel');
  }
  function realCount(track) {
    return slice(track.children).filter(function (c) { return !c.hasAttribute('data-rev-fallback') && !c.hasAttribute('data-wf-skel-card'); }).length;
  }
  function mountTrack(track) {
    if (!track) return true;
    if (track.getAttribute('data-wf-marquee')) return true; // already mounted
    if (realCount(track) < 2) return false;                 // only fallback/skeleton so far - wait
    clearSkeleton(track);
    slice(track.querySelectorAll('[data-rev-fallback]')).forEach(function (f) { if (f.parentNode) f.parentNode.removeChild(f); });
    setup(track);
    return true;
  }
  // Watch for the async review fetch to inject cards, then mount. Only called
  // once the section has neared the viewport (see armTrack).
  function watchTrack(track) {
    if (track.getAttribute('data-wf-watch')) return; track.setAttribute('data-wf-watch', '1');
    if (mountTrack(track)) return;
    try { var mo = new MutationObserver(function () { if (mountTrack(track)) mo.disconnect(); }); mo.observe(track, { childList: true }); } catch (e) {}
    [400, 900, 1600, 2800, 4500].forEach(function (d) { setTimeout(function () { mountTrack(track); }, d); }); // safety net if the observer misses
  }
  // Perf: defer the image upgrade (~1MB of review photos) + the marquee rAF loop
  // until the reviews section is ~1 screen away - so it never steals bandwidth
  // from the LCP hero (reviews live below the fold). Bonus: a display:none box
  // never intersects, so the hidden opposite-viewport track (the desktop track on
  // mobile & vice-versa) stays fully dormant instead of styling+cloning cards for
  // nothing. Falls back to immediate mount where IntersectionObserver is missing.
  // When the section nears the viewport: mount immediately if the real reviews are
  // already in; otherwise show the skeleton and watch for them to land.
  function onNear(track) {
    if (mountTrack(track)) return;
    showSkeleton(track);
    watchTrack(track);
  }
  function armTrack(track) {
    if (track.getAttribute('data-wf-armed')) return; track.setAttribute('data-wf-armed', '1');
    if ('IntersectionObserver' in window) {
      try {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); onNear(track); } });
        }, { rootMargin: '300px 0px' });
        io.observe(track);
        return;
      } catch (e) {}
    }
    onNear(track); // no IO support → mount/skeleton as before
  }
  function go() {
    try { injectCardCss(); } catch (e) {}  // cheap: card styling + hide prev/next now, loads no images
    try { slice(document.querySelectorAll('.mhv2__test-track')).forEach(armTrack); } catch (e) {}
    try { initPartners(); } catch (e) {}
  }
  // Run a touch late so the section's own JS (and the review fetch) begin first.
  function start() { setTimeout(go, 500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
